export const getAssetBaseUrl = () => {
    const configuredApi = String(process.env.REACT_APP_API_URL || '').trim();

    if (/^https?:\/\//i.test(configuredApi)) {
        return configuredApi.replace(/\/api\/?$/, '');
    }

    const { protocol, hostname, port, origin } = window.location;

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        if (port === '3000') {
            return `${protocol}//${hostname}:5000`;
        }
    }

    return origin;
};

export const toAssetUrl = (value) => {
    if (!value) return '';
    if (/^https?:\/\//i.test(value)) return value;
    return `${getAssetBaseUrl()}${value}`;
};
